import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { ParsedUrlQuery } from 'querystring';
import { InstantSearchSSRProvider } from 'react-instantsearch-hooks-web';
// import { getServerState } from '@/lib/algolia/getServerState';
import { getServerState } from 'react-instantsearch-hooks-server';
import Layout from '@/components/layout';
import { Search } from '@/cataloguePages/productCategory/Search';
import { getNavigation } from '@/lib/sanity/queries';
import { NextSeo } from 'next-seo';
import { renderToString } from 'react-dom/server';
import { baseUrl } from '@/lib/utils/getUrls';
import { SearchProps } from '@/lib/algolia/createCategorySearchProps';

export interface Params extends ParsedUrlQuery {
  slugs?: string | string[];
}

const NyheterPage = ({
  searchServerState,
  searchProps,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const title = 'Nyheter';

  return (
    <InstantSearchSSRProvider {...searchServerState}>
      <Layout
        breadcrumbs={[
          {
            name: 'Nyheter',
            path: '/nyhter',
            isCurrent: true,
          },
        ]}
      >
        <NextSeo title={title} />
        <h1 className="mb-6 hd-3xl">Nyheter</h1>
        <Search {...searchProps} />
      </Layout>
    </InstantSearchSSRProvider>
  );
};

export default NyheterPage;

export const getStaticProps: GetStaticProps = async (context) => {
  const navigation = await getNavigation();
  const facetFilters = [`tags:nyhet`];

  const searchProps: SearchProps = {
    facetFilters,
    slugs: [],
    showCategories: false,
    placeholder: 'Søk i nyheter',
    searchServerState: null,
    serverUrl: `${baseUrl}/nyheter`,
    rootPath: 'nyheter',
    categoryRootPath: null,
    categorySlugsRootPath: null,
    hierarchicalMenu: null,
    categoryType: null,
    nextRouter: null,
    categories: null,
    categorySlugs: null,
    articleGroups: null,
    articleGroupSlugs: null,
    algoliaProductCategory: null,
    articleGroupsRootPath: null,
    articleGroupSlugsRootPath: null,
    sessionStorageCache: null,
  };

  // const searchServerState = await getServerState(
  //   <Search {...searchProps} key="nyheter-ssr" />,
  //   { renderToString }
  // );

  // searchProps.searchServerState = searchServerState;

  return {
    props: {
      navigation,
      searchProps,
    },
    revalidate: 60 * 60,
  };
};
